import { render, staticRenderFns } from "./endetzxaj.vue?vue&type=template&id=140432b8&scoped=true&"
import script from "./endetzxaj.vue?vue&type=script&lang=js&"
export * from "./endetzxaj.vue?vue&type=script&lang=js&"
import style0 from "./endetzxaj.vue?vue&type=style&index=0&id=140432b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140432b8",
  null
  
)

export default component.exports